/** /hava-durumu girişinde öne çıkan iller (tek şehre kilitlenmez). */
export const POPULAR_WEATHER_CITIES = [
  'İstanbul',
  'Ankara',
  'İzmir',
  'Bursa',
  'Antalya',
  'Adana',
  'Trabzon',
  'Konya',
  'Ağrı',
  'Van',
] as const

/** 81 il — backend DEFAULT_TR_CITIES ile senkron tutulmalı. */
export const TR_WEATHER_CITIES = [
  'Adana',
  'Adıyaman',
  'Afyonkarahisar',
  'Ağrı',
  'Amasya',
  'Ankara',
  'Antalya',
  'Artvin',
  'Aydın',
  'Balıkesir',
  'Bilecik',
  'Bingöl',
  'Bitlis',
  'Bolu',
  'Burdur',
  'Bursa',
  'Çanakkale',
  'Çankırı',
  'Çorum',
  'Denizli',
  'Diyarbakır',
  'Edirne',
  'Elazığ',
  'Erzincan',
  'Erzurum',
  'Eskişehir',
  'Gaziantep',
  'Giresun',
  'Gümüşhane',
  'Hakkari',
  'Hatay',
  'Isparta',
  'Mersin',
  'İstanbul',
  'İzmir',
  'Kars',
  'Kastamonu',
  'Kayseri',
  'Kırklareli',
  'Kırşehir',
  'Kocaeli',
  'Konya',
  'Kütahya',
  'Malatya',
  'Manisa',
  'Kahramanmaraş',
  'Mardin',
  'Muğla',
  'Muş',
  'Nevşehir',
  'Niğde',
  'Ordu',
  'Rize',
  'Sakarya',
  'Samsun',
  'Siirt',
  'Sinop',
  'Sivas',
  'Tekirdağ',
  'Tokat',
  'Trabzon',
  'Tunceli',
  'Şanlıurfa',
  'Uşak',
  'Van',
  'Yozgat',
  'Zonguldak',
  'Aksaray',
  'Bayburt',
  'Karaman',
  'Kırıkkale',
  'Batman',
  'Şırnak',
  'Bartın',
  'Ardahan',
  'Iğdır',
  'Yalova',
  'Karabük',
  'Kilis',
  'Osmaniye',
  'Düzce',
] as const

/** ASCII slug for /hava-durumu/{slug} URLs (ağrı → agri). */
export function cityToSlug(city: string) {
  return foldCityKey(city).replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')
}

/** Diacritic-folded key for search / match (Ağrı → agri). */
export function foldCityKey(v: string) {
  return v
    .trim()
    .toLocaleLowerCase('tr-TR')
    .replace(/ı/g, 'i')
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ş/g, 's')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c')
    .replace(/[’'".,()]/g, '')
}

function titleCaseTr(s: string) {
  return s
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toLocaleUpperCase('tr-TR') + w.slice(1))
    .join(' ')
}

export function resolveCanonicalCity(input: string): string | null {
  const n = foldCityKey(input).replace(/\s+/g, ' ')
  for (const c of TR_WEATHER_CITIES) {
    if (foldCityKey(c) === n) return c
  }
  return null
}

/** Uzun il slug’ları önce (afyonkarahisar). */
const TR_CITY_SLUGS = [...TR_WEATHER_CITIES]
  .map((c) => cityToSlug(c))
  .sort((a, b) => b.length - a.length)

/**
 * Map URL slug back to canonical TR city name.
 * Lossy ASCII slugs (agri) must be resolved via the known cities list.
 * Eski ilçe slug’ları (istanbul-besiktas) → il (İstanbul).
 */
export function resolveCityFromSlug(
  slug: string,
  cities: Array<{ city: string }> = [],
): string {
  const raw = decodeURIComponent(slug || '').trim()
  const normalized = cityToSlug(raw.replace(/\s+/g, '-'))

  const fromArg = cities.find((c) => cityToSlug(c.city) === normalized)
  if (fromArg?.city) return fromArg.city

  const fromBuiltin = TR_WEATHER_CITIES.find((c) => cityToSlug(c) === normalized)
  if (fromBuiltin) return fromBuiltin

  for (const citySlug of TR_CITY_SLUGS) {
    if (normalized === citySlug || normalized.startsWith(`${citySlug}-`)) {
      const city = TR_WEATHER_CITIES.find((c) => cityToSlug(c) === citySlug)
      if (city) return city
    }
  }

  return resolveCanonicalCity(raw.replace(/-/g, ' ')) ?? titleCaseTr(raw.replace(/-/g, ' '))
}

export function cityPath(city: string) {
  return `/hava-durumu/${cityToSlug(city)}`
}

export function mergeWeatherCities(
  apiCities: Array<{ city: string }>,
): Array<{ city: string }> {
  const bySlug = new Map<string, string>()
  for (const c of TR_WEATHER_CITIES) bySlug.set(cityToSlug(c), c)
  for (const c of apiCities) {
    if (c?.city) bySlug.set(cityToSlug(c.city), c.city)
  }
  return Array.from(bySlug.values()).map((city) => ({ city }))
}
